import Flickity from 'flickity';

export default class RelatedCustomerStories {
  constructor() {
    const $els = document.querySelectorAll('.js-related-customer-stories-carousel');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.$carousel = this.$el.querySelector('.js-related-customer-stories-carousel-carousel');
    this.flickity = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      contain: 'true',
      cellAlign: 'left',
      groupCells: true
    });
  }
}
